var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          staticClass: "tabs-container",
          staticStyle: { position: "relative" }
        },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "AMS", name: "ams", lazy: true } },
                [
                  _vm.amsIsLink
                    ? _c("ams-info-ai", {
                        ref: "ams",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "tab-name": _vm.activeTabName,
                          ams2: _vm.ams2,
                          form: _vm.form,
                          container: _vm.container,
                          pm: _vm.pm,
                          "local-data": _vm.localData,
                          "cooperate-edit": _vm.cooperateEdit
                        }
                      })
                    : _c("ams-info", {
                        ref: "ams",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "show-code-search": true,
                          "tab-name": _vm.activeTabName,
                          ams2: _vm.ams2,
                          "is-js": _vm.isJs,
                          form: _vm.form,
                          container: _vm.container,
                          pm: _vm.pm,
                          "local-data": _vm.localData,
                          "cooperate-edit": _vm.cooperateEdit
                        }
                      })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "ISF", name: "isf", lazy: true } },
                [
                  _c("ams-info", {
                    ref: "isf",
                    attrs: {
                      context: _vm.context,
                      action: _vm.action,
                      "show-i-s-f": true,
                      "tab-name": _vm.activeTabName,
                      ams2: _vm.ams2,
                      form: _vm.form,
                      container: _vm.container,
                      pm: _vm.pm,
                      "local-data": _vm.localData,
                      "cooperate-edit": _vm.cooperateEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "ACI", name: "aci", lazy: true } },
                [
                  _c("ams-info", {
                    ref: "aci",
                    attrs: {
                      context: _vm.context,
                      action: _vm.action,
                      "show-code-search": true,
                      "tab-name": _vm.activeTabName,
                      ams2: _vm.ams2,
                      form: _vm.form,
                      container: _vm.container,
                      pm: _vm.pm,
                      "party-name-list": _vm.partyNameList,
                      "local-data": _vm.localData,
                      "cooperate-edit": _vm.cooperateEdit,
                      "is-js": _vm.isJs
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: { label: "eManifest", name: "eManifest", lazy: true }
                },
                [
                  _c("ams-info", {
                    ref: "eManifest",
                    attrs: {
                      context: _vm.context,
                      action: _vm.action,
                      "show-code-search": true,
                      "show-second-notify-party": true,
                      "tab-name": _vm.activeTabName,
                      ams2: _vm.ams2,
                      form: _vm.form,
                      container: _vm.container,
                      pm: _vm.pm,
                      "local-data": _vm.localData,
                      "cooperate-edit": _vm.cooperateEdit
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "AFR", name: "afr", lazy: true } },
                [
                  _vm.afrIsLink
                    ? _c("afr-info-ai", {
                        ref: "afr",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "tab-name": _vm.activeTabName,
                          afr2: _vm.afr2,
                          form: _vm.afrForm,
                          container: _vm.afrContainer,
                          pm: _vm.pm,
                          "local-data": _vm.localData,
                          "cooperate-edit": _vm.cooperateEdit
                        }
                      })
                    : _c("afr-info", {
                        ref: "afr",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "show-code-search": true,
                          "tab-name": _vm.activeTabName,
                          afr2: _vm.afr2,
                          "master-info": _vm.masterInfo,
                          form: _vm.afrForm,
                          container: _vm.afrContainer,
                          pm: _vm.pm,
                          "local-data": _vm.localData,
                          "cooperate-edit": _vm.cooperateEdit,
                          "is-js": _vm.isJs
                        }
                      })
                ],
                1
              ),
              _vm.showThailandFlag
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: { label: "Thailand", name: "thailand", lazy: true }
                    },
                    [
                      _c("thailand-info", {
                        attrs: {
                          action: _vm.action,
                          thailand2: _vm.thailand2,
                          form: _vm.thailandForm,
                          container: _vm.thailandContainer,
                          job: _vm.job,
                          "txt-carrier-sc-ac": _vm.localData.carrierScAc,
                          "cooperate-edit": _vm.cooperateEdit
                        },
                        on: {
                          syncThailandInfo: function(field) {
                            _vm.pm.syncThailandInfo(field)
                          },
                          synchroThailandClickHandler: function($event) {
                            return _vm.pm.btnSynchroThailandClickHandler()
                          },
                          removeCargoDoc: function($event) {
                            return _vm.pm.onRemoveThailandCargoDoc()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isNewWindowByENS
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "ENS", name: "ens", lazy: true } },
                    [
                      _c("ens-info", {
                        ref: "ens",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "show-code-search": true,
                          "tab-name": _vm.activeTabName,
                          ams2: _vm.ams2,
                          form: _vm.form,
                          container: _vm.container,
                          pm: _vm.pm,
                          "local-data": _vm.localData,
                          "cooperate-edit": _vm.cooperateEdit
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isNewWindowByENS
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "ENS", name: "ens", lazy: true } },
                    [
                      _c("ens-info-ai", {
                        ref: "ens",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "show-code-search": true,
                          "tab-name": _vm.activeTabName,
                          ams2: _vm.ams2,
                          form: _vm.form,
                          container: _vm.container,
                          pm: _vm.pm,
                          "local-data": _vm.localData,
                          "cooperate-edit": _vm.cooperateEdit
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cooperateEdit,
                  expression: "cooperateEdit"
                }
              ],
              style: {
                position: "absolute",
                left: !_vm.job.lclMasterUuid ? "430px" : "380px"
              }
            },
            [
              _vm.activeTabName === "thailand"
                ? [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "108px" },
                        attrs: {
                          disabled: _vm.thailandEdit,
                          type: "primary",
                          no: "1"
                        },
                        on: { click: _vm.sendInThailand }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Send")))]
                    )
                  ]
                : (_vm.tabEns && _vm.isNewWindowByENS) ||
                  (_vm.tabAms && _vm.amsIsLink) ||
                  (_vm.tabAfr && _vm.afrIsLink)
                ? [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "" : "not-click",
                        staticStyle: { "padding-left": "110px" },
                        attrs: {
                          title: _vm.$t("SeaExport.send"),
                          disabled: !_vm.readonly,
                          "split-button": "",
                          type: "primary",
                          no: "3"
                        },
                        on: {
                          command: function(p) {
                            return _vm.pm.send(p.type, p.index)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(this.getItemTitle("Send")) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          _vm._l(_vm.sendTypes, function(item) {
                            return _c(
                              "el-dropdown-item",
                              {
                                key: item.label,
                                attrs: {
                                  disabled: !item.enabled,
                                  command: item
                                }
                              },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _vm.activeTabName !== "afr"
                      ? _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              disabled: _vm.activeTabName === "afr",
                              title: _vm.$t("SeaExport.DoNotImportAndSend"),
                              no: "2"
                            },
                            model: {
                              value: _vm.amsCheck,
                              callback: function($$v) {
                                _vm.amsCheck = $$v
                              },
                              expression: "amsCheck"
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Import only")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "" : "not-click",
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-right": "5px"
                        },
                        attrs: {
                          title: _vm.$t("SeaExport.send"),
                          disabled: !_vm.readonly,
                          "split-button": "",
                          type: "primary",
                          no: "3"
                        },
                        on: {
                          command: function(p) {
                            return _vm.pm.send(p.type, p.index)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(this.getItemTitle("Send")) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          _vm._l(_vm.sendTypes, function(item) {
                            return _c(
                              "el-dropdown-item",
                              {
                                key: item.label,
                                attrs: {
                                  disabled: !item.enabled,
                                  command: item
                                }
                              },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    !_vm.isJs
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: _vm.$t("SeaExport.CheckStatus"),
                              no: "4"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.queryAMS()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Query Status")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.ViewReceipt"),
                          type: "primary",
                          no: "5"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.queryAMSReceiptInfoClickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Receipt")))]
                    ),
                    _vm.isJs && _vm.tabAms
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.jsError,
                              title: _vm.$t("SeaExport.Error"),
                              type: "primary",
                              no: "4"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.queryJsAmsErrorMessage()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Error")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showExcel,
                            expression: "showExcel"
                          }
                        ],
                        attrs: {
                          title: _vm.$t("SeaExport.DownloadTemplate"),
                          type: "primary",
                          no: "6"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onDownloadTemplateRelease()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Template Download")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabEManifest && !_vm.isJs,
                            expression: "tabEManifest && !isJs"
                          }
                        ],
                        attrs: {
                          title: _vm.$t("SeaExport.DownloadTemplate"),
                          type: "primary",
                          no: "6"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onDownloadTemplateRelease()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Template Download")))]
                    ),
                    _c(
                      "el-dropdown",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabIsf && !_vm.isJs,
                            expression: "tabIsf && !isJs"
                          }
                        ],
                        staticStyle: { "margin-left": "5px" },
                        attrs: { "split-button": "", type: "primary", no: "1" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command)
                          },
                          command: function(p) {
                            _vm.command = p
                            _vm.commandHandle(_vm.command)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getItemTitle("Template Download")) +
                            " "
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "ISF5" } },
                              [_vm._v(_vm._s(_vm.$t("Message.ISF5File")))]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "ISF10" } },
                              [_vm._v(_vm._s(_vm.$t("Message.ISF10File")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showExcel &&
                              !_vm.tabAfr &&
                              !_vm.isJs &&
                              !_vm.tabEns,
                            expression:
                              "showExcel && !tabAfr && !isJs && !tabEns"
                          }
                        ],
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "5px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          action: "string",
                          "http-request": _vm.importAMSExcel,
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "before-upload": _vm.beforeUpload
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              disabled: _vm.readonly,
                              title: _vm.$t("SeaExport.ImportEXCEL"),
                              type: "primary",
                              no: "7"
                            },
                            slot: "trigger"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Import Template")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showExcel && _vm.tabAfr && !_vm.isJs,
                            expression: "showExcel && tabAfr && !isJs"
                          }
                        ],
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "5px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          action: "string",
                          "http-request": _vm.importAFRExcel,
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "before-upload": _vm.beforeUpload
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              disabled: _vm.readonly,
                              title: _vm.$t("SeaExport.ImportEXCEL"),
                              type: "primary",
                              no: "8"
                            },
                            slot: "trigger"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Import Template")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabEns,
                            expression: "tabEns"
                          }
                        ],
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "5px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          action: "string",
                          "http-request": _vm.importEnsExcel,
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "before-upload": _vm.beforeUpload,
                          no: "uploadJs"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              disabled: _vm.readonly,
                              title: _vm.$t("SeaExport.ImportEXCEL"),
                              type: "primary",
                              no: "importExcelJs"
                            },
                            slot: "trigger"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Import Template")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showExcel &&
                              _vm.isJs &&
                              (_vm.tabAms || _vm.tabAfr || _vm.tabAci),
                            expression:
                              "showExcel && isJs && (tabAms || tabAfr || tabAci)"
                          }
                        ],
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "5px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          action: "string",
                          "http-request": _vm.importJsExcel,
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "before-upload": _vm.beforeUpload,
                          no: "uploadJs"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              disabled: _vm.readonly,
                              title: _vm.$t("SeaExport.ImportEXCEL"),
                              type: "primary",
                              no: "importExcelJs"
                            },
                            slot: "trigger"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Import Template")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabIsf && !_vm.isJs,
                            expression: "tabIsf && !isJs"
                          }
                        ],
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "5px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          action: "string",
                          "http-request": _vm.importIsfExcel,
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "before-upload": _vm.beforeUpload
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              disabled: _vm.readonly,
                              title: _vm.$t("SeaExport.ImportEXCEL"),
                              type: "primary"
                            },
                            slot: "trigger"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Import Template")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabEManifest && !_vm.isJs,
                            expression: "tabEManifest && !isJs"
                          }
                        ],
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "5px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          action: "string",
                          "http-request": _vm.importEManifestExcel,
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "before-upload": _vm.beforeUpload
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              disabled: _vm.readonly,
                              title: _vm.$t("SeaExport.ImportEXCEL"),
                              type: "primary"
                            },
                            slot: "trigger"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Import Template")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !_vm.tabAfr &&
                              !(_vm.isJs && (_vm.tabAms || _vm.tabAci)),
                            expression:
                              "!tabAfr && !(isJs && (tabAms || tabAci))"
                          }
                        ],
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary", no: "9" },
                        on: { click: _vm.jumpToCargo }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SwitchToTheOldVersion"))
                        )
                      ]
                    )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _vm.receiptInfoDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "receiptInfoDialog",
                visible: _vm.receiptInfoDialog.visible,
                title: _vm.receiptInfoDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.receiptInfoDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { height: "350px" },
                attrs: {
                  no: "receiptInfoDialog",
                  "v-if": !(_vm.isTradetech && _vm.deleteAMS),
                  "grid-options": _vm.receiptInfoDialog.gridOptions,
                  "column-defs": _vm.receiptColumnDefs,
                  "row-data": _vm.receiptInfoDialog.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.receiptInfoDialog.gridApi = params.api
                  }
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "11" },
                      on: {
                        click: function($event) {
                          _vm.receiptInfoDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.tradetechReceiptInfoDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "tradetechReceiptInfoDialog",
                visible: _vm.tradetechReceiptInfoDialog.visible,
                title: _vm.tradetechReceiptInfoDialog.title,
                "config-module": "20240304",
                width: "1000px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(
                    _vm.tradetechReceiptInfoDialog,
                    "visible",
                    $event
                  )
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { height: "350px" },
                attrs: {
                  no: "tradetechReceiptInfoDialog",
                  "v-if": _vm.isTradetech && _vm.deleteAMS,
                  "grid-options": _vm.tradetechReceiptInfoDialog.gridOptions,
                  "column-defs": _vm.tradetechReceiptColumnDefs,
                  "row-data": _vm.tradetechReceiptInfoDialog.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.tradetechReceiptInfoDialog.gridApi = params.api
                  }
                }
              }),
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "990004",
                  total: _vm.tradetechReceiptInfoDialog.filter.total,
                  "page-count": _vm.tradetechReceiptInfoDialog.filter.pageCount,
                  page: _vm.tradetechReceiptInfoDialog.filter.pageNum,
                  limit: _vm.tradetechReceiptInfoDialog.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.tradetechReceiptInfoDialog.filter,
                      "pageNum",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(
                      _vm.tradetechReceiptInfoDialog.filter,
                      "pageSize",
                      $event
                    )
                  },
                  pagination: _vm.toTradetechQueryByPage
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "11" },
                      on: {
                        click: function($event) {
                          _vm.tradetechReceiptInfoDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.afrXmlDialog.visible,
            title: "Preview Message",
            width: "600px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.afrXmlDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "afrContent",
            staticStyle: { height: "560px" },
            attrs: { no: "afrContent", "text-chars": 0, "warning-count": -1 },
            model: {
              value: _vm.afrXmlDialog.content,
              callback: function($$v) {
                _vm.$set(_vm.afrXmlDialog, "content", $$v)
              },
              expression: "afrXmlDialog.content"
            }
          }),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success", no: "12" },
                  on: {
                    click: function($event) {
                      return _vm.pm.sendAfrEFreightXml()
                    }
                  }
                },
                [_vm._v(_vm._s("Send"))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "13" },
                  on: {
                    click: function($event) {
                      return _vm.pm.downloadTxtFile()
                    }
                  }
                },
                [_vm._v("Export Current Page")]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "14" },
                  on: {
                    click: function($event) {
                      _vm.afrXmlDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s("Close"))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.amsXmlDialog.visible,
            title: "Preview Message",
            width: "600px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.amsXmlDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "amsContent",
            staticStyle: { height: "560px" },
            attrs: { no: "amsContent", "text-chars": 0, "warning-count": -1 },
            model: {
              value: _vm.amsXmlDialog.content,
              callback: function($$v) {
                _vm.$set(_vm.amsXmlDialog, "content", $$v)
              },
              expression: "amsXmlDialog.content"
            }
          }),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.tabEns
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", no: "15" },
                      on: {
                        click: function($event) {
                          return _vm.pm.sendENSxml(_vm.ensIndex)
                        }
                      }
                    },
                    [_vm._v(_vm._s("Send"))]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "success", no: "15" },
                      on: {
                        click: function($event) {
                          _vm.currentType === "ISF10" ||
                          _vm.currentType === "ISF05"
                            ? _vm.pm.sendISFXml(
                                _vm.currentIndex,
                                _vm.currentType
                              )
                            : _vm.pm.sendAmsXml()
                        }
                      }
                    },
                    [_vm._v(_vm._s("Send"))]
                  ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "16" },
                  on: {
                    click: function($event) {
                      return _vm.pm.downloadAMSTxtFile()
                    }
                  }
                },
                [_vm._v("Export Current Page")]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "17" },
                  on: {
                    click: function($event) {
                      _vm.amsXmlDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s("Close"))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "thailand-export",
          attrs: {
            visible: _vm.thailandExportDialog.visible,
            title: _vm.thailandExportDialog.showReminder
              ? "Reminder"
              : "Preview Message",
            width: "600px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.thailandExportDialog, "visible", $event)
            }
          }
        },
        [
          _vm.thailandExportDialog.showReminder
            ? _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("i", {
                      staticClass: "el-icon-warning",
                      staticStyle: { color: "#E6A23C", "font-size": "20px" }
                    })
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { "flex-grow": "1" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "5px",
                          "line-height": "20px"
                        }
                      },
                      [_vm._v("These fields may have issues")]
                    ),
                    _c("cargo-rich-textarea", {
                      staticStyle: { height: "480px" },
                      attrs: { "text-chars": 0, "warning-count": -1, no: "18" },
                      model: {
                        value: _vm.thailandExportDialog.reminderContent,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.thailandExportDialog,
                            "reminderContent",
                            $$v
                          )
                        },
                        expression: "thailandExportDialog.reminderContent"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          !_vm.thailandExportDialog.showReminder
            ? _c("cargo-rich-textarea", {
                staticStyle: { height: "500px" },
                attrs: { "text-chars": 0, "warning-count": -1, no: "19" },
                model: {
                  value: _vm.thailandExportDialog.content,
                  callback: function($$v) {
                    _vm.$set(_vm.thailandExportDialog, "content", $$v)
                  },
                  expression: "thailandExportDialog.content"
                }
              })
            : _vm._e(),
          _vm.thailandExportDialog.showReminder
            ? _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "20" },
                      on: {
                        click: function($event) {
                          _vm.thailandExportDialog.showReminder = false
                        }
                      }
                    },
                    [_vm._v("Continue")]
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.thailandExportDialog.showReminder
            ? _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "21" },
                      on: { click: _vm.doExportThailand }
                    },
                    [_vm._v("Export Current Page")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "22" },
                      on: {
                        click: function($event) {
                          _vm.thailandExportDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s("Close"))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.jsAfrDeleteDialog.visible,
            title: _vm.jsAfrDeleteDialog.title,
            "before-close": _vm.jsAfrDeleteClose,
            width: "450px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.jsAfrDeleteDialog, "visible", $event)
            }
          }
        },
        [
          _c("br"),
          _c("br"),
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-weight": "bold" } },
            [
              _vm._v(
                "Are you sure you want to delete? Please select the reason for deletlon."
              )
            ]
          ),
          _c("br"),
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "DeletionReason", "label-width": "120px" } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "options-width": "205px;",
                      no: "57",
                      "static-options": _vm.SystemConstants.JS_AFR_DELETE,
                      cache: false,
                      clearable: false,
                      "default-value": _vm.jsAfrDeleteDialog.deletionCode,
                      "tag-name": "chineseName",
                      "tag-value": "code"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.jsAfrDeleteDialog.deletionCode = p.value
                        _vm.jsAfrDeleteDialog.deletionReason = p.chineseName
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("br"),
          _c("br"),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.pm.confirmDeletion()
                    }
                  }
                },
                [_vm._v("Confirm")]
              ),
              _c("el-button", { on: { click: _vm.jsAfrDeleteClose } }, [
                _vm._v("Cancel")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.deleteReasonDialog.visible,
            title: _vm.$t("Message.ReasonForDeletion"),
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.deleteReasonDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "deleteReasonForm",
              attrs: {
                model: _vm.deleteReasonDialog,
                rules: _vm.deleteReasonRules,
                "label-width": "120px"
              }
            },
            [
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { prop: "reasonCode", required: "" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(_vm.$t("Message.ReasonForDeletion")) + "：")
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("SeaExport.WseDeleteReasonNotEmpty")
                      },
                      on: { change: _vm.onDeleteReasonChange },
                      model: {
                        value: _vm.deleteReasonDialog.reasonCode,
                        callback: function($$v) {
                          _vm.$set(_vm.deleteReasonDialog, "reasonCode", $$v)
                        },
                        expression: "deleteReasonDialog.reasonCode"
                      }
                    },
                    _vm._l(_vm.deleteReasonOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.Instructions") + "：",
                    prop: "reasonDescription",
                    "label-width": "120px"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: _vm.$t("SeaExport.ExplanationRequired")
                    },
                    model: {
                      value: _vm.deleteReasonDialog.reasonDescription,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.deleteReasonDialog,
                          "reasonDescription",
                          $$v
                        )
                      },
                      expression: "deleteReasonDialog.reasonDescription"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmDeleteReason }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ConfirmDeletion")))]
              ),
              _c("el-button", { on: { click: _vm.cancelDeleteReason } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("dialog-selector", {
        attrs: {
          visible: _vm.selectorDialog.visible,
          title: _vm.selectorDialog.title,
          "row-data": _vm.selectorDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectorDialog, "visible", $event)
          },
          selected: _vm.selectorDialogCallback
        }
      }),
      _c("message-preview-dialog", {
        attrs: {
          visible: _vm.messagePreviewDialog.visible,
          params: _vm.messagePreviewDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
          },
          uploadSuccess: function($event) {
            _vm.messagePreviewDialog.visible = false
          }
        }
      }),
      _c("ens-receipt-details-dialog", {
        attrs: {
          pm: _vm.pm,
          visible: _vm.ensDataStatusDialog.visible,
          "job-no": _vm.ensDataStatusDialog.jobNo,
          "hbl-nbr2": _vm.ensDataStatusDialog.hblNbr2,
          "is-chinese-language": _vm.ensDataStatusDialog.isZh,
          type: _vm.ensDataStatusDialog.type,
          "tab-name": _vm.activeTabName
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.ensDataStatusDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }